<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ userInfo.suffix }}</p>
      <small>{{ userInfo.phone }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <!--        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40"-->
        <!--             height="40" class="rounded-full shadow-md cursor-pointer block"/>-->
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40"
             height="40" class="rounded-full shadow-md cursor-pointer block"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="gotoProfile">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Profile</span>
          </li>

          <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>-->

          <vs-divider class="m-1"/>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import logout from '../../../../graphql/Logout.gql'
  import {onLogout} from '../../../../vue-apollo'
  import { ME } from '../../../../graphql/userinfo'

  export default {
    data() {
      return {
        userInfo: {
          ekyc:{
            status:''
          }
        },
        colorx:'success'
      }
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.userInfo = data.me
            console.log("Main LLLLLLLLL", this.userInfo);
          }
        }
      }
    },
    computed: {
      activeUserInfo () {
        return this.$store.state.AppActiveUser
      }
    },
    methods: {
      async logout () {
        console.log('Logout Innnnn')
        await this.$apollo.mutate({
          mutation: logout
        }).then((data) => {
          console.log('Logout ', data)
          if (data) {
            console.log('Logout Innnnn hhh')
            onLogout(this.$apollo.provider.defaultClient)
            localStorage.removeItem('apollo-token')
            window.localStorage.clear()
            this.$router.push('/pages/login').catch(() => {})
            this.$vs.notify({
              title: 'Log Out',
              text: "You are logout successfully",
              color: "success",
              position: 'top-right'
            })
            console.log('Logout')
            window.localStorage.clear();
            //window.location.reload();
          }
          //location.reload()
        }).catch((error) => {
          console.log('dddd', error)
        })
      },
      test () {

        console.log('removeToken')
      },
      gotoProfile () {
        this.$router.push('/showroomProfile').catch(() => {
        })
        console.log('goto')
      }
    }
  }
</script>
